<div class="loading-screen-wrapper" *ngIf="loading">
  <div class="loading-screen-icon">
    Loading...
  </div>
</div>